import { Component, OnInit } from '@angular/core';
import { ResponsiveLayoutService } from 'src/app/services/responsive-layout.service';
import { ModalAlertComponent } from 'src/app/shared/modal-alert/modal-alert.component';
import { formatNumber } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.css']
})
export class SalesComponent implements OnInit {
  data$!: string;
  mapHeader = {
    order_buy: { display: 'Orden Compra', data: null },

    razon_social: { display: 'Nombre', data: null },
    email: { display: 'Mail', data: null },
    rut: { display: 'RUT', data: null },
    giro: { display: 'Giro', data: null },
    address_payment: { display: 'Dirección', data: null },
    phone: { display: 'Teléfono', data: null },

    product: { display: 'Producto', data: null },
    product_sap: { display: 'Código SAP', data: null },
    plant: { display: 'Planta', data: null },

    total_price: { display: 'Precio Total', data: null },
    request_amount: { display: 'Cantidad', data: null },
    address_dispatch: { display: 'Dirección Despacho', data: null },
    address_latitud: { display: 'Latitud', data: null },
    address_longitud: { display: 'Longitud', data: null },

    schedule: { display: 'Fecha', data: null },
    hours: { display: 'Rango Horario', data: null },

    state: { display: 'Estado', data: null },
    created_at: { display: 'Solicitado', data: null },
    date_buy: { display: 'Día de Pago', data: null },

    pedido: { display: 'Pedido SAP', data: null },
    factura: { display: 'Factura SAP', data: null },
    authorization_code: { display: 'Código de Autorización', data: null },
    ejecutivo_email: { display: 'Ejecutivo', data: null },

    address_complementary_dispatch: { display: 'Dirección Complementaria', data: null },
    address_complementary_latitud: { display: 'Latitud Complementaria', data: null },
    address_complementary_longitud: { display: 'Longitud Complementaria', data: null },
    sujeta_factibilidad: { display: 'Sujeta a Factibilidad', data: null },

    actions: {
      display: 'Acciones',
      sort: false,
      data: (data: any) => {
        return `
        <div>
              <button class="btn btn-link btn-action" title="Variables Utilizadas" data-bs-toggle="tooltip" data-action="seeVariables" title="Revisar Variables"">
                <svg class="bi" width="20" height="20" fill="currentColor">
                  <use xlink:href="assets/img/bootstrap-icons.svg#eye" />
                </svg>
              </button>
        <div>
              `;
      },
      seeVariables: (data: any) => { this.onseeValues(data); }
    },
  };


  constructor(
    private readonly modalService: NgbModal,
    public responsiveService: ResponsiveLayoutService
  ) {
  }

  /**
   * Funcion para revisar los valores utilizado en los calculos
   * @param ele 
   */
  onseeValues(ele: any) {
    const modalRef = this.modalService.open(ModalAlertComponent, { centered: true });
    modalRef.componentInstance.title = `Valores Pedido ${ele.order_buy}`;
    modalRef.componentInstance.accion = 'Ok';
    let mensaje = ''
    mensaje += `<br><strong>Planta</strong>: ${ele.plant}`
    mensaje += `<br><strong>Cantidad</strong>: ${ele.request_amount} m<sup>3</sup>`
    mensaje += `<br><strong>Día</strong>: ${ele.dia}`
    mensaje += `<br><strong>Sección</strong>: ${ele.seccion}`
    mensaje += `<br><strong>Horario</strong>: ${ele.hours}`
    
    mensaje += `<br><strong>UF</strong>: ${this.convertValue(ele.uf, '1.0')} CLP`
    mensaje += `<br><strong>Precio Unitario  </strong>: ${this.convertValue(ele.producto_unitario, '1.0')} UF`
    mensaje += `<br><strong>Precio Carga Incompleta</strong>: ${this.convertValue(ele.carga_incompleta)} UF`
    mensaje += `<br><strong>Precio Ajuste Horario</strong>: ${this.convertValue(ele.factor_price, '1.0')} UF`

    modalRef.componentInstance.descriptionHTML = mensaje;
    modalRef.componentInstance.function = () => {
      this.modalService.dismissAll();
    };
  }
  /**
   * Devuelve string formateado desde un nunmero
   * @param numero 
   * @param formato 
   * @returns 
   */
  convertValue(numero: any, formato: string = '1.1') {
    try {
      return formatNumber(numero, 'es-CL', formato);
    } catch (ex) {
      console.log(`error conversion [${ex}]`)
      return ''
    }
  }





  ngOnInit(): void {
    this.data$ = 'dispatch/';
  }
}
